import {
  GroupInterface,
  LocationCardNearPostalCodeInterface,
  LocationInterface,
  LocationVarKey,
  LocationWithVariablesInterface,
  UserAddress
} from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/Locations/Locations.Controller.ts
export class LocationsAPI {
  static async getGroupsAndLocations(orgId: number) {
    return APIService.Server.get<GroupInterface[]>(`/locations/org/${orgId}/groups-and-locations`);
  }
  static async getGroupsAndLocationsInternal(orgId: number) {
    return APIService.Server.get<GroupInterface[]>(`/locations/org/${orgId}/groups-and-locations-internal`);
  }
  static async createLocation(orgId: number, name: string, groupId: number) {
    return APIService.Server.post<LocationInterface>(`/locations/org/${orgId}/location`, { name, groupId });
  }
  static async setGroupForLocation(orgId: number, locationId: number, groupId: number) {
    return APIService.Server.put<LocationInterface>(`/locations/org/${orgId}/location/${locationId}/group/${groupId}`);
  }
  static async createGroup(orgId: number, name: string) {
    return APIService.Server.post<GroupInterface>(`/locations/org/${orgId}/group`, { name });
  }
  static async deleteLocation(orgId: number, locationId: number) {
    return APIService.Server.delete(`/locations/org/${orgId}/location/${locationId}`);
  }
  static async deleteGroup(orgId: number, groupId: number) {
    return APIService.Server.delete(`/locations/org/${orgId}/group/${groupId}`);
  }

  /**
   * Location cards near a postal code (ENG-2723/2867): Cortex card vars +
   * distanceMiles + availableUnitCount, assembled server-side. The bot's
   * find_locations geo branch consumes this instead of raw var reads.
   */
  static async getLocationCardsNearPostalCode(orgId: number, postalCode: string, distance: number) {
    return APIService.Server.get<LocationCardNearPostalCodeInterface[]>(`/locations/org/${orgId}/cards-near-postal-code`, {
      postalCode,
      distance
    });
  }

  static async getLocationsNearPostalCode(orgId: number, postalCode: string, distance: number) {
    return APIService.Server.get<
      LocationWithVariablesInterface<
        | LocationVarKey.CountryCode
        | LocationVarKey.PostalCode
        | LocationVarKey.BrandId
        | LocationVarKey.AvatarURL
        | LocationVarKey.Address
        | LocationVarKey.City
        | LocationVarKey.State
      >[]
    >(`/locations/org/${orgId}/near-postal-code`, { postalCode, distance });
  }
  static async getLocationByURL(orgId: number, url: string) {
    return APIService.Server.get<LocationWithVariablesInterface<any>[]>(`/locations/org/${orgId}/by-url`, { url: url });
  }

  static async getLocationVariablesForAllLocations<T extends LocationVarKey>(
    orgId: number,
    locationVarKeys: T[]
  ): Promise<LocationWithVariablesInterface<T>[]> {
    return APIService.Server.get<LocationWithVariablesInterface<T>[]>(`/locations/org/${orgId}/location-variables-for-all-locations`, {
      locationVarKeys
    });
  }
}
